import React, { useState } from 'react';
import { useForm } from 'react-hook-form';
import DatePicker from 'react-datepicker';
import 'react-datepicker/dist/react-datepicker.css';
import { useLocation } from 'react-router-dom';
import StripeWrapper from '../components/StripeWrapper';
import CheckoutForm from '../components/CheckoutForm';

function Booking() {
  const { register, handleSubmit } = useForm();
  const [submitted, setSubmitted] = useState(false);

  const location = useLocation();
  const searchParams = new URLSearchParams(location.search);
  const selectedRoom = searchParams.get('room') || '';
  const selectedPrice = parseInt(searchParams.get('price')) || 5000;
  const selectedDate = searchParams.get('date') ? new Date(searchParams.get('date')) : new Date();
  const [date, setDate] = useState(selectedDate);

  const onSubmit = async (data) => {
    const bookingData = {
      name: data.name,
      email: data.email,
      room: selectedRoom,
      date: date.toDateString(),
      notes: data.notes,
    };

    try {
      // Send booking data to the server
      await fetch('http://localhost:4000/api/booking', {
        method: 'POST',
        body: JSON.stringify(bookingData),
        headers: { 'Content-Type': 'application/json' },
      });

      setSubmitted(true);
    } catch (error) {
      alert('Something went wrong. Please try again.');
    }
  };

  if (submitted) {
    return (
      <div className="p-10 text-center text-green-700 font-bold">
        Thank you! Your booking request has been sent.
        <div className="mt-6">
          <StripeWrapper>
            <CheckoutForm amount={selectedPrice} />
          </StripeWrapper>
        </div>
      </div>
    );
  }

  return (
    <div className="p-10 max-w-xl mx-auto">
      {submitted ? (
        <div className="text-green-600 font-semibold text-center">
          ✅ Your booking has been submitted!
          <div className="mt-6">
            <StripeWrapper>
              <CheckoutForm amount={selectedPrice} />
            </StripeWrapper>
          </div>
        </div>
      ) : (
        <form onSubmit={handleSubmit(onSubmit)} className="space-y-4">
          <input
            {...register('name')}
            placeholder="Name"
            required
            className="w-full p-2 border rounded"
          />
          <input
            {...register('email')}
            type="email"
            placeholder="Email"
            required
            className="w-full p-2 border rounded"
          />
          {selectedRoom && (
            <input
              type="text"
              value={selectedRoom}
              readOnly
              className="w-full p-2 border bg-gray-100 text-gray-700"
            />
          )}
          <DatePicker
            selected={date}
            onChange={(d) => setDate(d)}
            className="w-full p-2 border rounded"
          />
          <textarea
            {...register('notes')}
            placeholder="Special Requests"
            className="w-full p-2 border rounded"
          />
          <button
            type="submit"
            className="bg-blue-700 text-white px-6 py-2 rounded hover:bg-blue-800"
          >
            Submit Booking
          </button>
        </form>
      )}
    </div>
  );

}

export default Booking;
